export const MESSAGES = {
  5: {
    type: 'dialog',
    pt: 'Salve antes as edições deste registro.',
    en: 'Please save the record changes first.',
  },
  15: {
    type: 'question',
    pt: 'Você tem certeza que deseja excluir este registro?',
    en: 'Are you sure you want to delete this record?',
  },
  285: {
    type: 'warning',
    pt: 'Por favor, preencha os campos obrigatórios antes de continuar.',
  },
  593: {
    type: 'error',
    pt: 'O chamado indicado não tem orçamento de tal prestador para importar.',
  },
  594: { type: 'error', pt: 'O chamado indicado não tem o orçamento na nova estrutura.' },
  610: {
    type: 'warning',
    pt: 'Não há prestadores disponíveis para o chamado em questão nem na base de dados da Refera.',
  },
  613: {
    type: 'warning',
    pt: '"Você já atingiu o número máximo de prestadores indicados pela Refera nesta categoria.\nPara obter mais indicações, exclua antes alguns destes prestadores.',
  },
  623: {
    type: 'error',
    pt: 'A "Área de atuação" conflita com o "Tipo de contrato" da intermediária.',
  },
  499: {
    type: 'error',
    pt: 'Registro já existente.',
    en: 'Already existing record.',
  },
  639: {
    type: 'error',
    pt: 'Todos os registros devem ter o campo Cômodo preenchido para prosseguir com o ajuste de orçamento.',
  },
  641: {
    type: 'error',
    pt: 'Para chamados de desocupação, só se pode anexar um único documento.',
  },
  643: {
    type: 'error',
    pt: 'Usuário sem vínculo com intermediária.',
  },
}
